import { connect } from 'react-redux';
import actions from '../redux/actions/setting_data';
import ShowCryptoSetting from '../component/ShowCryptoSetting';

const mapStateToProps = (state) => ({
  coins: state.setting.coins,
  arrCoins: state.setting.arrCoins,
  cryptoSettings: state.setting.cryptoSettings,
  publicKeys: state.setting.publicKeys,
});

const mapDispatchToProps = (dispatch) => ({
  onFetchCryptoExchangeConfigAction: () => {
    dispatch(actions.fetchCryptoExchangeConfigAction());
  },
  onFetchListPublicKeyActiveListCryptoAction: (params, callback) => {
    dispatch(actions.fetchListPublicKeyActiveListCryptoAction(params, callback));
  },
  deletePublicKeyActiveListCryptoAction: (params, callback) => {
    dispatch(actions.deletePublicKeyActiveListCryptoAction(params, callback));
  },
  addPublicKeyToActiveListCryptoAction: (params, callback) => {
    dispatch(actions.addPublicKeyToActiveListCryptoAction(params, callback));
  },
  updateCryptoExchangeConfigAction: (params, callback) => {
    dispatch(actions.updateCryptoExchangeConfigAction(params, callback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowCryptoSetting);
